// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre[data-v-a9188f22]{word-wrap:break-word;white-space:pre;white-space:pre-wrap;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;font-size:85%;font-weight:900;background-color:#fbe5e1;color:#c0341d;padding:.2rem .4rem;margin:0 0 24px}", ""]);
// Exports
module.exports = exports;
